var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8016 16.1984V9.19836C25.8016 8.71512 25.4099 8.32336 24.9266 8.32336C24.4434 8.32336 24.0516 8.71512 24.0516 9.19836V15.3234H17.9266C17.4434 15.3234 17.0516 15.7151 17.0516 16.1984C17.0516 16.6816 17.4434 17.0734 17.9266 17.0734H24.9266C25.4099 17.0734 25.8016 16.6816 25.8016 16.1984Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8078 13.3172L24.3078 16.8172C24.4719 16.9812 24.6945 17.0734 24.9266 17.0734C25.1587 17.0734 25.3812 16.9812 25.5453 16.8172C25.7094 16.6531 25.8016 16.4304 25.8016 16.1984C25.8016 15.9663 25.7094 15.7438 25.5453 15.5797L22.0453 12.0797C19.6055 9.63863 16.2203 8.96491 16.2203 8.96491C12.8352 8.2912 9.64641 9.61222 9.64641 9.61222C6.45766 10.9332 4.54069 13.8035 4.54069 13.8035C2.62381 16.6736 2.625 20.125 2.625 20.125C2.62509 20.3571 2.71736 20.5799 2.88151 20.7439C3.04559 20.9079 3.26805 21 3.5 21C3.98312 20.9998 4.375 20.6081 4.375 20.125C4.37399 17.2046 5.99597 14.7754 5.99597 14.7754C7.61802 12.3468 10.3162 11.229 10.3162 11.229C13.0144 10.1112 15.8787 10.6812 15.8787 10.6812C18.7431 11.2513 20.8078 13.3172 20.8078 13.3172Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferIcon);
export default __webpack_public_path__ + "static/media/transferIcon.7faf44ec2307d1d3098c2727de405856.svg";
export { ForwardRef as ReactComponent };